import xScroll from "components/_x-scroll/x-scroll";
import { VueAppObserver } from "./vueAppObserve";

export default function () {
  /*
    @todo: convert xScroll import to dynamic import if .xScroll class exists
    @todo: above todo was using parcel. new todo, if sticking with vite is to move xscroll back into respective components
 */
  xScroll();

  // Opens FAQ accordions when their designated hash is in the URL
  const hash = location.hash;
  if (hash) {
    const id = hash.substring(1);
    //pass attribute in case id starts with a number
    //see https://bobbyhadz.com/blog/javascript-failed-to-execute-queryselector-on-document
    const details = document.querySelector(`details[id='${id}']`);
    if (details) details.open = true;
  }
  //Event listener for details-summary disclosures to set their id as the hash
  const disclosures = document.querySelectorAll("details");
  disclosures.forEach((el) => {
    if (el.hasAttribute("id")) {
      const id = el.getAttribute("id");
      el.addEventListener("toggle", (event) => {
        const hash = location.hash;
        if (el.open) {
          history.replaceState(null, "", `#${id}`);
        } else if (!el.open && hash === `#${id}`) {
          history.replaceState(null, "", " ");
        }
      });
    }
  });

  //Initiate Intersection Observer for `.js-observe`
  document.querySelectorAll(".js-observe:not(.js-observed)").forEach((el) => {
    VueAppObserver.observe(el);
  });
}
